@for (data of list['events']; track data; let i = $index) {
  @if ((i == 0) || (data['day'] != list['events'][i-1]['day'])) {
    <h2 class="mb-3">
    {{data['day']}} {{data['month_caption']}}</h2>
  }
  <app-calendar-event (onDelete)="whenDelete(data)" [data]="data"></app-calendar-event>
}

<app-help-calendar-list>
</app-help-calendar-list>
